import { cn } from "@reactive-resume/utils";

type Props = {
  size?: number;
  className?: string;
};

export const Icon = ({ size = 32, className }: Props) => {
  return (
    <img
      src="/logo/brand-logo.png"
      width={size}
      height={size}
      alt="Brand Logo"
      className={cn("rounded-sm object-contain", className)}
    />
  );
};
